// extracted by mini-css-extract-plugin
export default {"payableInbox":"PayableInbox_payableInbox__pr6u5","footerText":"PayableInbox_footerText__hkPeQ"};